import { render, staticRenderFns } from "./skillManageList.vue?vue&type=template&id=4b20877c&scoped=true"
import script from "./skillManageList.vue?vue&type=script&lang=js"
export * from "./skillManageList.vue?vue&type=script&lang=js"
import style0 from "./skillManageList.vue?vue&type=style&index=0&id=4b20877c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b20877c",
  null
  
)

export default component.exports